import React, { FC } from 'react';
import { AuthPageWrapper } from '../AuthPageLayout';
import { ForgotPasswordPage } from 'features';

/**
 * A React component that renders the forgot password page layout.
 * @returns The rendered forgot password page layout.
 */
export const ForgotPassword: FC = () => {
  return (
    <AuthPageWrapper>
      <ForgotPasswordPage />
    </AuthPageWrapper>
  );
};
